<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
        <chart-card
          :chart-data="dailySalesChart.data"
          :chart-options="dailySalesChart.options"
          :chart-type="'Line'"
          data-background-color="blue"
          :key="reRender"
        >
          <template slot="content">
            <h4 class="title">Daily Sales</h4>
            <p class="category" v-if="increase > 0">
              <span class="text-success">
                <i class="fas fa-long-arrow-alt-up"></i>
                {{ increase }}%
              </span>
              increase in today sales.
            </p>
            <p class="category" v-else>
              <span class="text-danger">
                <i class="fas fa-long-arrow-alt-down"></i>
                {{ increase }}%
              </span>
              decrease in today sales.
            </p>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>Up To Date
            </div>
          </template>
        </chart-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
        <chart-card
          :chart-data="GenderSalesGraph.data"
          :chart-options="GenderSalesGraph.options"
          :chart-responsive-options="GenderSalesGraph.responsiveOptions"
          :chart-type="'Bar'"
          :key="reRender"
          data-background-color="red"
        >
          <template slot="content">
            <h4 class="title">Products Sold By Gender</h4>
            <p class="category">Last Campaign Performance</p>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>Up To Date
            </div>
          </template>
        </chart-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
        <chart-card
          :chart-data="GenderRevenueGraph.data"
          :chart-options="GenderRevenueGraph.options"
          :chart-responsive-options="GenderRevenueGraph.responsiveOptions"
          :chart-type="'Bar'"
          :key="reRender"
          data-background-color="green"
        >
          <template slot="content">
            <h4 class="title">Revenue Generated By Gender</h4>
            <p class="category">Last Campaign Performance</p>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>Up To Date
            </div>
          </template>
        </chart-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>store</md-icon>
          </template>

          <template slot="content">
            <p class="category">Revenue</p>
            <h3 class="title">${{ revenue }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>date_range</md-icon>Last 24 Hours
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>content_copy</md-icon>
          </template>

          <template slot="content">
            <p class="category">Number Of Orders</p>
            <h3 class="title">{{ numberOfOrders }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>Over All
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="red">
          <template slot="header">
            <md-icon>info_outline</md-icon>
          </template>

          <template slot="content">
            <p class="category">New Users</p>
            <h3 class="title">+{{ numberOfNewUsers }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>date_range</md-icon>In The Last Month
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="blue">
          <template slot="header">
            <i class="fab fa-twitter"></i>
          </template>

          <template slot="content">
            <p class="category">Users</p>
            <h3 class="title">{{ numberOfUsers }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>Over All
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
        <md-card>
          <md-card-header data-background-color="red">
            <h4 class="title">Best Sold Products</h4>
          </md-card-header>
          <md-card-content>
            <OrderedTableForSales table-header-color="red" :products="bestSales"></OrderedTableForSales>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Most 10 Rated Products</h4>
          </md-card-header>
          <md-card-content>
            <OrderedTableForRanking table-header-color="green" :products="mostRated"></OrderedTableForRanking>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  StatsCard,
  ChartCard,
  OrderedTableForSales,
  OrderedTableForRanking
} from "@/components";
import axios from "axios";

export default {
  components: {
    StatsCard,
    ChartCard,
    OrderedTableForRanking,
    OrderedTableForSales
  },
  data() {
    return {
      dailySalesChart: {
        data: {
          labels: ["J-6", "J-5", "J-4", "J-3", "J-2", "J-1", "J0"],
          series: [[0, 0, 0, 0, 0, 0, 0]]
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 50,
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      GenderRevenueGraph: {
        data: {
          labels: ["Women", "Men"],
          series: [[0, 0]]
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        }
      },
      GenderSalesGraph: {
        data: {
          labels: ["Women", "Men"],
          series: [[0, 0]]
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },
      increase: 0,
      reRender: 0,
      revenue: 0,
      bestSales: null,
      numberOfOrders: 0,
      numberOfUsers: 0,
      numberOfNewUsers: 0,
      mostRated: null,
      dailyRevenue: null,
      bestSalesByBrand: null,
      salesByGender: null
    };
  },
  methods: {
    getRevenue() {
      return axios
        .get("https://prodigy-rbk.herokuapp.com/api/orders/revenue")
        .then(({ data }) => (this.revenue = data));
    },
    getBestSales() {
      return axios
        .get("https://prodigy-rbk.herokuapp.com/api/orders/bestSales")
        .then(({ data }) => (this.bestSales = data));
    },
    getNumberOfOrders() {
      return axios
        .get("https://prodigy-rbk.herokuapp.com/api/orders/numberOfOrders")
        .then(({ data }) => (this.numberOfOrders = data));
    },
    getNumberOfUsers() {
      return axios
        .get("https://prodigy-rbk.herokuapp.com/api/user/numberOfUser")
        .then(({ data }) => (this.numberOfUsers = data));
    },
    getNumberOfNewUsers() {
      return axios
        .get("https://prodigy-rbk.herokuapp.com/api/user/numberOfNewUser/30")
        .then(({ data }) => (this.numberOfNewUsers = data));
    },
    getMostRatedProducts() {
      return axios
        .get("https://prodigy-rbk.herokuapp.com/api/products/mostRated")
        .then(({ data }) => (this.mostRated = data));
    },
    getDailyRevenue() {
      return axios
        .get("https://prodigy-rbk.herokuapp.com/api/orders/revenueDaily")
        .then(({ data }) => (this.dailyRevenue = data));
    },
    getBestSalesByBrand() {
      return axios
        .get("https://prodigy-rbk.herokuapp.com/api/orders/bestSalesByBrand")
        .then(({ data }) => (this.bestSalesByBrand = data));
    },
    getSalesByGender() {
      return axios
        .get("https://prodigy-rbk.herokuapp.com/api/orders/salesbyGender")
        .then(({ data }) => (this.salesByGender = data));
    },
    createRevenueCart(array) {
      const series = [[]];
      let date = new Date().getDate();
      let i = 0;

      while (series[0].length < 7) {
        let day = parseInt(array[i]._id.slice(8));
        if (day === date) {
          series[0].unshift(array[i].amount);
          if (this.dailySalesChart.options.high < array[i].amount) {
            this.dailySalesChart.options.high = array[i].amount + 1500;
          }
          i++;
        } else {
          series[0].unshift(0);
        }
        date--;
      }
      this.increase = (
        ((series[0][series[0].length - 1] - series[0][series[0].length - 2]) /
          series[0][series[0].length - 2]) *
        100
      ).toFixed(2);
      this.dailySalesChart.data.series = series;
      this.reRender += 1;
    },
    createGenderSalesGraph(array) {
      if (array[0]._id === "Women") {
        this.GenderSalesGraph.data.series[0][0] = array[0].products.length;
        this.GenderRevenueGraph.data.series[0][0] = array[0].amount;
        this.GenderSalesGraph.data.series[0][1] = array[1].products.length;
        this.GenderRevenueGraph.data.series[0][1] = array[1].amount;
      } else {
        this.GenderSalesGraph.data.series[0][0] = array[1].products.length;
        this.GenderRevenueGraph.data.series[0][0] = array[1].amount;
        this.GenderSalesGraph.data.series[0][1] = array[0].products.length;
        this.GenderRevenueGraph.data.series[0][1] = array[0].amount;
      }
      this.GenderRevenueGraph.options.high = array[0].amount + 500;
      this.GenderSalesGraph.options.high = array[0].products.length + 10;
      this.reRender += 1;

      // const productsSold = array[0].products.length + array[1].products.length;
    }
  },
  async beforeMount() {
    var datePointer = new Date().getDay();
    var weekDays = [];
    for (var i = 0; i < 7; i++) {
      if (datePointer < 0) {
        datePointer += 7;
      }
      weekDays.unshift(this.$store.state.weekdays[datePointer]);
      datePointer--;
    }
    this.dailySalesChart.data.labels = weekDays;
    try {
      await Promise.all([
        this.getRevenue(),
        this.getBestSales(),
        this.getNumberOfOrders(),
        this.getNumberOfUsers(),
        this.getMostRatedProducts(),
        this.getNumberOfNewUsers(),
        this.getDailyRevenue(),
        this.getSalesByGender(),
        this.getBestSalesByBrand()
      ]);
    } catch (err) {}
    this.createRevenueCart(this.dailyRevenue);
    this.createGenderSalesGraph(this.salesByGender);
  },
  watch: {
    "dailySalesChart.data": function() {}
  }
};
</script>
